import React from "react";
import "./FloatingContactButtons.css";
import { PhoneOutlined, WhatsAppOutlined } from "@ant-design/icons";

const FloatingContactButtons = ({
  phoneNumber = "+919800040505",
  whatsappNumber = "+919800040505",
  whatsappMessage = "Hi, I would like to know more about your services!"
}) => {
  const whatsappLink = `https://wa.me/${whatsappNumber.replace(
    /[^0-9]/g,
    ""
  )}?text=${encodeURIComponent(whatsappMessage)}`;

  const phoneLink = `tel:${phoneNumber}`;

  return (
    <>
      {/* Phone */}
      <a href={phoneLink} className="fcb-btn fcb-phone pulse" aria-label="Call us">
        <PhoneOutlined className="fcb-icon" />
      </a>

      {/* WhatsApp */}
      <a
        href={whatsappLink}
        target="_blank"
        rel="noopener noreferrer"
        className="fcb-btn fcb-whatsapp pulse"
        aria-label="Chat on WhatsApp"
      >
        <WhatsAppOutlined className="fcb-icon" />
      </a>
    </>
  );
};

export default FloatingContactButtons;
